import _ from "lodash";
import { idsFarois } from "../../../../../constants/idsFarois";
import { nomesTogglesPorIdFarol } from "../../../../../constants/idsFarois";
import { opcoesFarolAltura } from "../../MenuLateral/Farol/farolContainerUtils";

const FAROIS_REBANHO = { PRESENCA_REBANHO: 11 };

const particionaFaroisPorToggle = (farois, nomesTogglesPorIdFarol) => {
  return _.partition(farois, (farol) => nomesTogglesPorIdFarol[farol.IdFarol]);
};

const montarObjetosToggleFarol = (farois, nomesTogglesPorIdFarol) => {
  const farolPorToggle = {};
  farois.forEach((farol) => {
    if (nomesTogglesPorIdFarol && nomesTogglesPorIdFarol[farol.IdFarol]) {
      const nomeToggle = nomesTogglesPorIdFarol[farol.IdFarol];
      farolPorToggle[nomeToggle] = farol;
    }
  });
  return farolPorToggle;
};
const filtraFaroisToggleDesabilitados = (farolPorToggle, Toggles) => {
  const arrayFaroisPorToggle = Object.entries(farolPorToggle);
  return arrayFaroisPorToggle.filter(([nomeToggle]) =>
    _.some(Toggles, (toggle) => toggle.Nome === nomeToggle && toggle.Ativo)
  );
};
const mapearFaroisFiltrados = (faroisToggle) => {
  return faroisToggle.map(([nome, farol]) => farol);
};

const deveExibirBotaoDetalhesRebanho = (tipoFarol) => {
  return tipoFarol === "rebanho";
};
const deveExibirBotaoDetalhesForragem = (
  exibirDetalhes,
  CiclosForragemFazenda,
  exibirFiltro,
  TipoFarol
) => {
  return (
    !exibirDetalhes &&
    CiclosForragemFazenda.length > 0 &&
    exibirFiltro &&
    TipoFarol === "altura-pasto"
  );
};

const deveExibirDetalhesRebanho = (
  exibirDetalhes,
  TipoFarol,
  farolSelecionado
) => {
  return (
    exibirDetalhes &&
    TipoFarol &&
    TipoFarol === "rebanho" &&
    Number(farolSelecionado) === idsFarois.rebanhoPresenca
  );
};
const deveExibirAvisoEntrevero = (TipoFarol, saldoDeEntreveroPorLote) => {
  const possuiEntrevero = Object.values(saldoDeEntreveroPorLote).some(
    (saldo) => saldo !== 0
  );

  return TipoFarol === "rebanho" && possuiEntrevero;
};

const deveExibirDropDownColeta = (exibirDetalhes, FazendaSelecionada) => {
  return !exibirDetalhes && FazendaSelecionada;
};

const deveExibirSelectFarois = (exibirFiltro, TipoFarol, exibirDetalhes) => {
  return exibirFiltro && TipoFarol && !exibirDetalhes;
};

const deveExibirFiltroPeriodo = (exibirDetalhes, exibirFiltro, TipoFarol) => {
  return (
    !exibirDetalhes &&
    exibirFiltro &&
    TipoFarol &&
    TipoFarol !== "rebanho" &&
    TipoFarol !== "sanidade"
  );
};

const deveExibirDetalhesForragem = (exibirDetalhes, TipoFarol) => {
  return exibirDetalhes && TipoFarol && TipoFarol === "altura-pasto";
};

const deveExibirAlbumFotoMorte = (TipoFarol, pastoSelecionado) => {
  return TipoFarol === "nascimento-morte" && pastoSelecionado.IdPasto !== null;
};

const ordenaFarois = (faroisOrdenar) => {
  return _.orderBy(faroisOrdenar, (farol) => farol.OrdemFarol);
};

const trataFaroisRenderizar = (farois, Toggles) => {
  const [faroisAfetados, faroisNaoAfetados] = particionaFaroisPorToggle(
    farois,
    nomesTogglesPorIdFarol
  );
  const objetoToggleFarol = montarObjetosToggleFarol(
    faroisAfetados,
    nomesTogglesPorIdFarol
  );
  const objetoToggleFarolFiltrado = filtraFaroisToggleDesabilitados(
    objetoToggleFarol,
    Toggles
  );
  const faroisAlteradosFiltrados = mapearFaroisFiltrados(
    objetoToggleFarolFiltrado
  );
  const faroisFiltrados = [...faroisNaoAfetados, ...faroisAlteradosFiltrados];
  const faroisOrdenados = ordenaFarois(faroisFiltrados);
  return faroisOrdenados;
};

const deveDesabilitarBotao = () => false;

const getDadosFarolEnviarGA = (farolSelecionado) => {
  let value = "";
  if (farolSelecionado === idsFarois.rebanhoPresenca) {
    value = "Farol Presença Rebanho";
  }
  const acao = `Ver detalhes de faróis Rebanho`;
  const rotulo = "Carga suporte";
  const categoria = "Análise";
  return { acao, rotulo, categoria, value };
};

const verificaToggleNascimentoMorte = (Toggles) => {
  const nascimento = verificaToggleNascimento(Toggles);
  const morte = verificaToggleMorte(Toggles);

  return nascimento || morte;
};

const retornaLabelNascimentoMorte = (t, Toggles) => {
  const nascimento = verificaToggleNascimento(Toggles);
  const morte = verificaToggleMorte(Toggles);

  if (nascimento && morte) return t("statusIndicator:birth-death");
  else if (nascimento) return t("statusIndicator:birth");
  else if (morte) return t("statusIndicator:death");
};

const verificaToggleNascimento = (Toggles) => {
  return _.some(Toggles, (t) => t.Nome === "COLETA_NASCIMENTO" && t.Ativo);
};

const verificaToggleCreep = (Toggles) => {
  return _.some(Toggles, (t) => t.Nome === "CREEP_MANEJO" && t.Ativo);
};

const verificaToggleMorte = (Toggles) => {
  return _.some(Toggles, (t) => t.Nome === "COLETA_MORTE" && t.Ativo);
};

const verificaToggleVisualizaGeolocalizacaoAlturaPasto = (Toggles) => {
  return _.some(
    Toggles,
    (t) => t.Nome === "VISUALIZA_GEOLOCALIZACAO_ALTURA_PASTO" && t.Ativo
  );
};

const constroiListaFarois = (t, toggles = [], isFazendaCreep, isClienteLite) => {
  const listaTiposColeta = [];

  if (toggles.some((t) => t.Nome === "COLETA_AGUADA" && t.Ativo)) {
    listaTiposColeta.push({ value: "aguada", label: t("statusIndicator:watery") });
  }
  if (!isClienteLite) {
    listaTiposColeta.push({
      value: "altura-pasto",
      label: t("statusIndicator:forage-height"),
    });
  }
  if (
    !isClienteLite &&
    toggles.some((t) => t.Nome === "COLETA_CERCA" && t.Ativo)
  ) {
    listaTiposColeta.push({ value: "cerca", label: t("statusIndicator:fence") });
  }
  listaTiposColeta.push({ value: "cocho", label: t("statusIndicator:trough") });
  if (!isClienteLite && verificaToggleCreep(toggles) && isFazendaCreep) {
    listaTiposColeta.push({ value: "cocho-creep", label: t("statusIndicator:creep-trough") });
  }
  if (
    !isClienteLite &&
    toggles.some((t) => t.Nome === "COLETA_FEZES" && t.Ativo)
  ) {
    listaTiposColeta.push({ value: "fezes", label: t("statusIndicator:stools") });
  }
  if (verificaToggleNascimentoMorte(toggles)) {
    listaTiposColeta.push({
      value: "nascimento-morte",
      label: retornaLabelNascimentoMorte(t, toggles),
    });
  }
  if (
    toggles.some(
      (t) => t.Nome === "COLETA_E_MOVIMENTACAO_DE_REBANHO" && t.Ativo
    )
  ) {
    listaTiposColeta.push({ value: "rebanho", label: t("statusIndicator:herd") });
  }
  if (
    !isClienteLite &&
    toggles.some((t) => t.Nome === "COLETA_SANIDADE" && t.Ativo)
  ) {
    listaTiposColeta.push({ value: "sanidade", label: t("statusIndicator:sanity") });
  }

  return listaTiposColeta;
};

/**
 * Calcula o saldo de animais por lote com base no array de lotes fornecido.
 * Retorna um Map onde a chave é composta por `pastureId-animalCategoryId` e o valor é o saldo de animais.
 *
 * @param {Array} lotes - Array de objetos representando os lotes.
 * @param {number} lotes[].pastureId - ID do pasto.
 * @param {number} lotes[].animalCategoryId - ID da categoria do animal.
 * @param {number} lotes[].number - Número de animais (positivo ou negativo).
 * @returns {Map<string, number>} - Um Map onde a chave é `pastureId-animalCategoryId` e o valor é o saldo de animais.
 *
 * @example
 * const lotesComEntrevero = [
 *   { id: 1, pastureId: 54349, animalCategoryId: 10005, number: 1, movementType: "Entrevero Positivo" },
 *   { id: 2, pastureId: 54349, animalCategoryId: 10005, number: -1, movementType: "Entrevero Negativo" },
 *   { id: 3, pastureId: 54352, animalCategoryId: 10004, number: -2, movementType: "Entrevero Positivo" },
 * ];
 *
 * const resultado = calcularSaldoPorLote(lotesComEntrevero);
 * console.log(resultado);
 * // Saída: { "54349-10005": 0, "54352-10004": -2 }
 */
const calcularSaldoDeEntreveroPorLote = (lotes) => {
  const saldoMap = new Map();

  lotes.forEach((lote) => {
    const key = `${lote.pastureId}-${lote.animalCategoryId}`;

    saldoMap.set(key, (saldoMap.get(key) || 0) + lote.number);
  });

  return Object.fromEntries(saldoMap);
};

export {
  filtraFaroisToggleDesabilitados,
  montarObjetosToggleFarol,
  particionaFaroisPorToggle,
  mapearFaroisFiltrados,
  FAROIS_REBANHO,
  deveExibirBotaoDetalhesRebanho,
  ordenaFarois,
  trataFaroisRenderizar,
  deveDesabilitarBotao,
  deveExibirDetalhesRebanho,
  getDadosFarolEnviarGA,
  deveExibirDropDownColeta,
  deveExibirSelectFarois,
  deveExibirFiltroPeriodo,
  deveExibirDetalhesForragem,
  deveExibirBotaoDetalhesForragem,
  deveExibirAlbumFotoMorte,
  verificaToggleNascimentoMorte,
  retornaLabelNascimentoMorte,
  verificaToggleNascimento,
  verificaToggleMorte,
  verificaToggleCreep,
  deveExibirAvisoEntrevero,
  constroiListaFarois,
  verificaToggleVisualizaGeolocalizacaoAlturaPasto,
  calcularSaldoDeEntreveroPorLote,
};
